import { STATE_AVAILABLE_TO_MARKET, STATE_PUBLISHED } from './states';

export const VALID_PUBLISHED_STATES = [STATE_AVAILABLE_TO_MARKET, STATE_PUBLISHED];
